export const handleChangeDataSurguryConsultationPage = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_SURGURY_CONSULTATION', name, value
});